export type ProfileAvatarUpload = { mime: "image/jpeg"; dataBase64: string };

export const profileCrop = (width: number, height: number): { x: number; y: number; sourceEdge: number; edge: number } => {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    throw new Error("Choose a valid image.");
  }
  const sourceEdge = Math.min(width, height);
  return { x: (width - sourceEdge) / 2, y: (height - sourceEdge) / 2, sourceEdge, edge: Math.min(512, sourceEdge) };
};

export const prepareProfileAvatar = async (file: File): Promise<ProfileAvatarUpload> => {
  if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) throw new Error("Choose a JPEG, PNG, or WebP image.");
  if (file.size > 10 * 1024 * 1024) throw new Error("Choose an image smaller than 10 MB.");
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    try { await image.decode(); } catch { throw new Error("This image could not be opened. Choose another photo."); }
    const crop = profileCrop(image.naturalWidth, image.naturalHeight);
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = crop.edge;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Your browser could not prepare this photo.");
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, crop.edge, crop.edge);
    context.drawImage(image, crop.x, crop.y, crop.sourceEdge, crop.sourceEdge, 0, 0, crop.edge, crop.edge);
    const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
    const prefix = "data:image/jpeg;base64,";
    if (!dataUrl.startsWith(prefix)) throw new Error("Your browser could not prepare this photo.");
    const dataBase64 = dataUrl.slice(prefix.length);
    if (atob(dataBase64).length > 512 * 1024) throw new Error("This photo is too large after cropping. Choose a smaller photo.");
    return { mime: "image/jpeg", dataBase64 };
  } finally { URL.revokeObjectURL(url); }
};
